import { makeStyles } from '@material-ui/styles';

const TABS_HEADER_DESKTOP_HEIGHT = 70;
const TABS_HEADER_MOBILE_HEIGHT = 50;

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
  },
  tabs: {
    height: TABS_HEADER_MOBILE_HEIGHT,
    boxShadow: '0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)',
    zIndex: 90,
    padding: [0, 28, 0, 28],
    [theme.breakpoints.up('mobile')]: {
      padding: [28, 28, 0, 28],
      height: TABS_HEADER_DESKTOP_HEIGHT,
    },
  },
  tab: {
    minWidth: 'unset',
    marginRight: 32,
  },
  content: {
    height: `calc(100% - ${TABS_HEADER_MOBILE_HEIGHT}px)`,
    [theme.breakpoints.up('mobile')]: {
      height: `calc(100% - ${TABS_HEADER_DESKTOP_HEIGHT}px)`,
    },
    padding: [0, 28, 0, 28],
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerControlPage/useStyles.js